/**
 *  추천 브랜드 페이지 이름
 */
export const RECOMMEND_STORE_PAGE_NAME = {
  RECOMMEND_STORE_LIST: '추천 브랜드 리스트',
  RECOMMEND_STORE_DETAIL: '추천 브랜드 상세',
  RECOMMEND_STORE_COPY: '추천 브랜드 복사',
  RECOMMEND_STORE_CREATE: '추천 브랜드 등록',
};

/**
 *  추천 브랜드 타입
 */
export const RECOMMEND_STORE_TYPE = {
  /**
   *  검색 화면 - 추천 후기
   */
  SEARCH_RECOMMEND: 0,
  /**
   *  상품 필터 화면 - 추천 브랜드
   */
  PRODUCT_FILTER_RECOMMEND: 1,
};

/**
 *  추천 브랜드 타입 텍스트
 */
export const RECOMMEND_STORE_TYPE_TEXT = {
  [RECOMMEND_STORE_TYPE.SEARCH_RECOMMEND]: '검색 추천',
  [RECOMMEND_STORE_TYPE.PRODUCT_FILTER_RECOMMEND]: '상품 필터 추천',
};

/**
 *  추천 브랜드 타입 SELECT 리스트
 */
export const RECOMMEND_STORE_TYPE_SELECT_LIST = [
  {
    id: RECOMMEND_STORE_TYPE.SEARCH_RECOMMEND,
    name: RECOMMEND_STORE_TYPE_TEXT[RECOMMEND_STORE_TYPE.SEARCH_RECOMMEND],
  },
  {
    id: RECOMMEND_STORE_TYPE.PRODUCT_FILTER_RECOMMEND,
    name: RECOMMEND_STORE_TYPE_TEXT[RECOMMEND_STORE_TYPE.PRODUCT_FILTER_RECOMMEND],
  },
];

/**
 *  추천 브랜드 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_STORE_MEMO = 2000;

/**
 *  추천 브랜드 아이템 최소 개수
 */
export const MINIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT = 3;

/**
 *  추천 브랜드 아이템 최대 개수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT = 5;

/**
 *  서브 텍스트 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_STORE_SUB_TEXT = 20;
